import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles({
  root: {
    padding: '38px 38px 25px 38px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  content: {
    marginTop: '28px',
    marginBottom: '25px',
  },
  footer: {
    '& button': {
      width: '100px',
      paddingLeft: 'auto',
      paddingRight: 'auto',
    },
    '& button:nth-child(1)': {
      marginRight: '10px',
    },
    '& button:nth-child(2)': {
      width: '152px',
      marginRight: '10px',
    },
  },
  rootNew: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
});
